import React, { useMemo, useState } from "react";
import { ShadcnButton } from "@components/items/display/ShadcnButton";
import { Server } from "@wajeez/wajeez.microservices";
import {
  checkPhoneNumber,
  requestPhoneNumberOtp,
  useAppDispatch,
  useRequestPhoneNumberOtp,
} from "@lib/stores";
import { AuthActions } from "@lib/stores/auth/slices";
import { PhoneInputV2 } from "@components/items/inputs/PhoneInputV2";
import PhoneNumberCodeForm from "../dialogs/PhoneOtp";
import TranslatedText from "@components/items/display/TranslatedText";

const ChangePhoneRow = ({ user }: { user: Server.AuthenticateOutput }) => {
  const dispatch = useAppDispatch();
  const [editState, setEditState] = useState<boolean>(false);
  const [isValidPhoneNumber, setIsValidPhoneNumber] = useState<boolean>(false);
  const [phone, setPhone] = useState<string>("");
  const [openOtpDialog, setOpenOtpDialog] = useState<boolean>(false);

  const buttonText = useMemo(() => {
    if (user.phoneNumber) {
      return editState ? "save" : "edit";
    }
    return editState ? "save" : "add phone number";
  }, [user.phoneNumber, editState]);

  const { status: requestPhoneNumberOtpStatus } = useRequestPhoneNumberOtp();

  const onRequestPhoneNumberOtpSubmit = (onSuccess?: () => void) => {
    requestPhoneNumberOtp({ phoneNumber: phone }, () => {
      setOpenOtpDialog(true);
      onSuccess && onSuccess();
    });
  };

  const onSubmit = async () => {
    try {
      if (phone) {
        checkPhoneNumber(phone, (res) => {
          setOpenOtpDialog(true);
          dispatch(
            AuthActions.requestPhoneNumberOtpAsync({ phoneNumber: phone })
          );
        });
      }
    } catch (error) {
      console.error("Error updating username:", error);
    }
  };

  return (
    <>
      {phone && (
        <PhoneNumberCodeForm
          phoneNumber={phone}
          open={openOtpDialog}
          onCancel={() => {
            setOpenOtpDialog(false);
          }}
          onCodeResend={onRequestPhoneNumberOtpSubmit}
          isCodeResendLoading={requestPhoneNumberOtpStatus === "loading"}
          setEditState={setEditState}
        />
      )}
      <div className="grid w-full grid-cols-3 items-center py-5">
        <TranslatedText
          text={`settings.titles.${"phone number"}`}
          className="text-black dark:text-white"
        />
        {user.phoneNumber ? (
          <PhoneInputV2
            useCase="setting"
            disabled={!editState}
            value={user.phoneNumber}
            onChange={(value: string) => {
              console.log("phone", phone);
              console.log("RRRRr", value);
              setPhone(value);
            }}
            setIsValidPhoneNumber={setIsValidPhoneNumber}
          />
        ) : editState ? (
          <PhoneInputV2
            useCase="setting"
            disabled={!editState}
            onChange={(value: string) => setPhone(value)}
            setIsValidPhoneNumber={setIsValidPhoneNumber}
          />
        ) : (
          <TranslatedText
            text={`settings.titles.${"not found"}`}
            className="text-black dark:text-white"
          />
        )}
        <ShadcnButton
          className="bg-transparent hover:bg-transparent"
          action={editState ? onSubmit : () => setEditState(true)}
          disabled={editState && !isValidPhoneNumber}
        >
          <TranslatedText
            text={`settings.titles.${buttonText}`}
            className="w-full cursor-pointer text-[15px] font-medium !text-primary hover:opacity-70 ltr:text-right rtl:text-left"
          />
        </ShadcnButton>
      </div>
    </>
  );
};

export default ChangePhoneRow;
